<template>
	<page>
		<listTemplate page-title="List" :pid="$cid.picture" :page-size="limit" type="picture"
			@article-click="itemClick"></listTemplate>
	</page>
</template>
<script>
	import listTemplate from "~/components/entemplate/listTemplate.vue";

	export default {
		components: {
			listTemplate,
		},
		data() {
			return {
				limit:9
			}
		},
		mounted() {
			if(document.getElementsByClassName('zui-page')[0].getAttribute("class").includes("mobileClass")){
				this.limit = 8
			}
		},
		methods: {
			itemClick(data) {
					const image = data.cover;
					this.$viewerApi({
						images: [image],
					})
			}
			
			// viewPicture() {
			// 	const image = this.pictureList[this.pictureIndex].src;
			// 	this.$viewerApi({
			// 		images: [image],
			// 	})
			// },
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/english/TravelInfo/Pictures.vue